import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
// import Ionicon from 'react-ionicons'
import Header from './widgets/Header'
import Nav from './widgets/Nav'
import {
  REDIRECT
} from '../constants/actionTypes'

const mapStateToProps = state => ({
  confirmInfo: state.common.confirmInfo,
  currentUser: state.common.currentUser,
})

const mapDispatchToProps = dispatch => ({
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class Page extends React.Component {
  constructor() {
    super()
    this.reset = (nextRoute) => {
      store.dispatch(push(nextRoute))
      this.props.onRedirect()
    }
  }
  componentWillReceiveProps(nextProps) {
  }
  componentWillUnmount() {
    if (this.props.confirmInfo) {
    }
  }

  render() {
    if (this.props.confirmInfo) {
      const confirmTitle = this.props.confirmInfo.confirmTitle
      const nextRoute = this.props.confirmInfo.nextRoute
      const nextRouteText = this.props.confirmInfo.nextRouteText
      const confirmText = this.props.confirmInfo.confirmText
      const type = this.props.confirmInfo.type
      return (
        <div id="main">
          <Nav selected={type} />
          <div className="content">
            <Header />
            <div id="content-clear">
              <div className="focus-wrap">
                <div className='box-header box-confirm-header'>
                  <h2>{confirmTitle}</h2>
                </div>
                <i id='confirm-icon' className="fad fa-check-circle"></i>
                <p id='confirm-text'>{confirmText}</p>
                <div className="form-item">
                  <button onClick={() => this.reset(nextRoute)}>{nextRouteText}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
